import { render } from "./VerCategorias.vue?vue&type=template&id=7a97631a"
import script from "./VerCategorias.vue?vue&type=script&lang=js"
export * from "./VerCategorias.vue?vue&type=script&lang=js"

import "./VerCategorias.vue?vue&type=style&index=0&id=7a97631a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__